<template>
	<r-standard-modal-form 
		:style="{
			width: `264px`,
		}"
		@closeModal="$emit('closeModal')"
	>
		<span slot="title">{{ titleText }}</span>
		<div slot="body" class="add-sheet-view-body">
			<template
				v-if="!sheetView"
			>
				<div class="input-header">View Type</div>
				<div class="type-container">
					<div class="radio-container">
						<template
							v-for="(tabTypeValue, index) in tabTypes"
						>
							<input 
								type="radio" 
								:id="tabTypeValue" 
								name="tabTypes" 
								:value="tabTypeValue" 
								:checked="index === 0"
								v-model="tabType"
								:key="tabTypeValue"
							/>
							<label 
								:for="tabTypeValue"
								:key="tabTypeValue+'label'"
								class="radio-label"
							>
								<r-standard-icon 
									v-if="tabType === tabTypeValue"
									icon="radioCheckmark"
									:size="15"
									:containerSize="15"
									class="check-icon"
								></r-standard-icon>
								<div 
									v-else
									class="check-spacer"
								></div>
								<span>{{ tabDetails[tabTypeValue].label }}</span>
							</label>
						</template>
					</div>
					<div class="describe-container">
						<div 
							class="svg-container"
						>
							<component 
								v-if="currentTabTypeExample" 
								:is="currentTabTypeExample"
							>		
							</component>
						</div>
					</div>
				</div>
			</template>
			<div>
				<div class="input-header">New View Name</div>
				<div class="name-container">
					<input 
						class="name-input"
						v-model="tabName"
						@keyup.enter.stop.prevent="addSheetView"
					/>
				</div>
			</div>
			<span class="input-header">
				Folder
				<r-tip-hover
					class="folder-help"
					position="top"
					text="All views in all folders always share the same up-to-date task data. Views in the same folder also share labels and colors."
				>
					<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="8.5" cy="8.5" r="8.5" fill="#E0E2E8"/>
						<path d="M7.63565 10.53V10.27C7.63565 9.81067 7.71365 9.412 7.86965 9.074C8.02565 8.736 8.21199 8.46733 8.42865 8.268C8.65399 8.06867 8.87499 7.88233 9.09165 7.709C9.30832 7.53567 9.49465 7.33633 9.65065 7.111C9.80665 6.877 9.88465 6.61267 9.88465 6.318C9.88465 5.928 9.75899 5.616 9.50765 5.382C9.25632 5.13933 8.90532 5.018 8.45465 5.018C7.92599 5.018 7.51432 5.174 7.21965 5.486C6.93365 5.78933 6.79065 6.22267 6.79065 6.786H5.43865C5.43865 5.85 5.71599 5.109 6.27065 4.563C6.82532 4.017 7.55332 3.744 8.45465 3.744C9.32999 3.744 10.0103 3.98667 10.4957 4.472C10.9897 4.94867 11.2367 5.564 11.2367 6.318C11.2367 6.708 11.1587 7.05467 11.0027 7.358C10.8467 7.66133 10.6603 7.90833 10.4437 8.099C10.227 8.28967 10.006 8.48033 9.78065 8.671C9.56399 8.86167 9.37765 9.09133 9.22165 9.36C9.06565 9.62867 8.98765 9.93633 8.98765 10.283V10.53H7.63565ZM8.29865 13.156C8.02132 13.156 7.78732 13.065 7.59665 12.883C7.41465 12.6923 7.32365 12.467 7.32365 12.207C7.32365 11.947 7.41465 11.7217 7.59665 11.531C7.78732 11.3403 8.02132 11.245 8.29865 11.245C8.56732 11.245 8.79699 11.3403 8.98765 11.531C9.18699 11.7217 9.28665 11.947 9.28665 12.207C9.28665 12.467 9.18699 12.6923 8.98765 12.883C8.79699 13.065 8.56732 13.156 8.29865 13.156Z" fill="#6A6B76"/>
					</svg>
				</r-tip-hover>				
			</span>
			<r-standard-selectfield
				ref="folder"
				slot="input"
				:field="folderState"
				:choiceArray="sheetViewGroupChoiceArray"
				hideValidationArea
			/>
			<r-button theme="dark-blue" fullWidth class="save-button" @click="addSheetView">
				Save
			</r-button>
		</div>
	</r-standard-modal-form>
</template>

<script>

// TODO: get choice array from imported Tab Type file
import CloudStore from 'js/cloudstore/cloudstore';
import BackgroundBus from 'js/bus/background-bus';
import SheetViewTypes from 'js/sheet-view/sheet-view-types';

// using this below to send into the selectfield because it doesn't like using Null as a GUID.
const ADD_NEW_SVG =  'lkasjdjhgtlkasjh';

export default {
	name: 'add-sheet-view-modal',
	$pubsub:{
		sheetViews:{
			
		}
	},
	data(){
		return {
			tabNameState: {},
			folderState: {},
			tabType: null,
			tabName: null,
		}
	},
	props:{
		dataStore:{
			required: true,
			type: Object,
		},
		sortedSheetViewGroups:{
			required: false,
			type: Array,
		},
		sheetView:{
			required: false,
			type: Object,
		},
	},
	mounted(){
		if(this.sheetView){
			this.tabType = this.sheetView.type;
			this.tabName = `Copy of ${this.sheetView.title}`;			
			this.$refs.folder.setValue(this.sheetView.sheetViewGroup.$internals.metaProperties.meta.guid);
		}
		else{
			this.tabType = this.tabTypes[0];
			this.tabName = `${this.tabTypeText} ${this.totalTabsInSelectedGroup}`;
		}

		const focusable = this.$el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
		if(focusable[0] && focusable[0].focus){
			focusable[0].focus();
		}
	},
	watch:{
		tabType(){
			if(!this.sheetView){
				this.tabName = `${this.tabTypeText} ${this.totalTabsInSelectedGroup}`;
			}
		}
	},
	computed:{
		sheetViewGroups(){
			if(this.sortedSheetViewGroups){
				return this.sortedSheetViewGroups;
			}
			else if(this.dataStore){
				return this.dataStore.sheetViewGroups.slice().sort(function compare(a, b){
					return a.$internals.metaProperties.meta.dateCreated - b.$internals.metaProperties.meta.dateCreated;
				});
			}
			else{
				return [];
			}
		},
		sheetViewGroupChoiceArray(){
			if(this.sheetViewGroups){
				return this.sheetViewGroups.map(function mapSheetViewToChoice(sheetViewGroup, index){
					return {
						label: `Folder ${index+1}`,
						value: sheetViewGroup.$internals.metaProperties.meta.guid,
					}
				}).concat([{
					label: `Folder ${this.sheetViewGroups.length+1} (create new)`,
					value: ADD_NEW_SVG,
				}]);
			}
			else{
				return [];
			}

		},
		tabTypeText(){
			if(this.tabType){
				return this.tabDetails[this.tabType].label;
			}
			else{
				return "";
			}
		},
		tabTypes(){
			return Object.keys(SheetViewTypes.types);
		},
		tabDetails(){
			let details = {};

			for(let sheetViewType in SheetViewTypes.types){
				details[sheetViewType] = {
					label: SheetViewTypes.types[sheetViewType].label,
					example: SheetViewTypes.types[sheetViewType].display.assets.example,
				}
			}


			return details;
		},
		totalTabsInSelectedGroup(){
			return this.sheetViewGroups.length;
		},
		currentTabTypeExample(){
			if(this.tabType){
				return this.tabDetails[this.tabType].example;
			}
			else{
				return null;
			}
		},
		titleText(){
			if(this.sheetView){
				return 'Duplicate View';
			}
			else{
				return 'New View';
			}
		},
	},
	methods:{
		addSheetView() {
			const rvSelf = this;
			const newTabName = rvSelf.tabName;
			const sheetViewGroupGUID = rvSelf.$refs.folder.value == ADD_NEW_SVG ? null : rvSelf.$refs.folder.value;

			if(rvSelf.sheetView) {
				rvSelf.sheetView.duplicate(newTabName, sheetViewGroupGUID, function withDuplicateSheetView(newSheetView){
					rvSelf.postSheetViewSave(newSheetView);
				});
			} else {
				rvSelf.postSheetViewSave(rvSelf.dataStore.addSheetView(newTabName, rvSelf.tabType, sheetViewGroupGUID));
			}
		},
		postSheetViewSave(newSheetView) {
			const rvSelf = this;
			BackgroundBus.pub("Registration", "conversionObjectiveCompleted", {
				objectiveName: "createdView",
				objectiveDetails: {
					values: [rvSelf.tabType]
				}
			});
			rvSelf.$nextTick(function afterTick(){
				rvSelf.$emit('closeModal');
				rvSelf.$pubsub.modules.sheetViews.pub('sheetViewSelected', {
					selectedSheetView: newSheetView,
				});
			});
		},
	}
}

</script>

<style scoped lang="scss">

.add-sheet-view-body{

	width: 100%;

	.input-header{
		font-family: $rvFontFamily;
		font-weight: 600;
		font-size: 13px;
		line-height: 19px;
		letter-spacing: 0.01em;
		color: $p-color-grey-400;
		margin-bottom: 6px;
		display: flex;
		align-items: center;
	}

	.folder-help{
		margin-left: 6px;
	}

	.type-container{
		@include flex(row, flex-start, flex-start);

		margin-bottom: 24px;

		.radio-container{

			background-color: $p-color-grey-100;
			min-height: 144px;

			.radio-label{
				@include flex(row);

				@include clickable;

				.check-icon{
					padding: 0 6px;
				}

				.check-spacer{
					width: 27px;
				}
			}

			.ignored-radio-label{
				width: 106px;
				height: 38px;
				background-color: $p-color-grey-100;
			}
		}

		.radio-container input[type="radio"] {
			opacity: 0;
			position: fixed;
			width: 0;
		}

		.radio-container label {
			display: block;
			padding: 9px 0;
			width: 106px;
			font-family: $rvFontFamily;
			font-weight: 500;
			font-size: 14px;
			line-height: 20px;
			letter-spacing: 0.15px;
			color: $p-color-grey-600;
			background-color: $p-color-grey-100;
		}

		.radio-container label:hover {

		}

		.radio-container input[type="radio"]:focus + label {

		}

		.radio-container input[type="radio"]:checked + label {
			color: $p-color-white;
			background-color: $p-color-blue-300;
			border-radius: 2px;
		}

		.describe-container{
			margin-left: 12px;
			flex-grow: 1;

			.svg-container{
				line-height: 0;

				&.fixed-height{
					height: 136px;
				}
			}

			.features-container{
				@include flex(column, flex-start, flex-start);

				.column-feature{
					@include flex(row);
					margin-bottom: 5px;
					cursor: default;

					.feature-icon{
						margin-right: 7px;
					}
					.feature-label{
						font-family: $rvFontFamily;
						font-weight: 500;
						font-size: 12px;
						line-height: 18px;
						letter-spacing: 0.15px;
						color: $p-color-grey-500;
					}
				}
			}
		}
	}

	.name-container{
		display: flex;
		margin-bottom: 18px;

		.name-input{
			font-family: $rvFontFamily;
			font-weight: 500;
			font-size: 14px;
			line-height: 20px;
			letter-spacing: 0.15px;
			color: $p-color-grey-600;
			padding: 10px 9px;
			border: 1px solid $p-color-grey-300;
			outline: none;
			width: 100%;

			&:focus{
				border: 1px solid $p-color-grey-600;
			}
		}
	}
}

.save-button{
	width: 100%;
	margin-bottom: 12px;
	margin-top: 36px;
}

.cancel-button{
	@include flex(row, center, center);

	.cancel-button-text{
		font-weight: 600;
		font-size: 14px;
		line-height: 21px;
		text-align: center;
		letter-spacing: 0.01em;
		color: $p-color-grey-500;

		@include clickable;
	}
}

.footer-area{
	height: 60px;
	margin: 12px 0 36px;

	.footer-text{
		font-weight: normal;
		font-size: 13px;
		line-height: 20px;
		letter-spacing: 0.1px;
		color: $p-color-grey-400;
	}
}

</style>